module.exports = __webpack_public_path__ + "static/wtf-edc5f9d28038d9b2dd276907f1df2051.png";